/**
 * 플랜 만료까지 남은 일수를 계산합니다.
 * @param expiryDate - 만료일 (YYYY-MM-DD 형식)
 * @returns 남은 일수 (정수)
 */
export const calculateDaysUntilExpiry = (expiryDate: string): number => {
  if (!expiryDate) return -1;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const expiry = new Date(expiryDate);
  expiry.setHours(0, 0, 0, 0);

  const diffTime = expiry.getTime() - today.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

/**
 * 만료 알림 타입을 결정합니다.
 * @param daysUntilExpiry - 남은 일수
 * @returns 알림 타입 ('D-7' | 'D-3' | 'D-day' | null)
 */
export const getExpirationAlertType = (
  daysUntilExpiry: number,
): 'D-7' | 'D-3' | 'D-day' | null => {
  // D-day: 남은 일수가 당일기준
  if (daysUntilExpiry === 0) {
    return 'D-day';
  }

  // D-3: 남은 일수가 2~3일 사이
  if (daysUntilExpiry <= 3) {
    return 'D-3';
  }

  // D-7: 남은 일수가 4~7일 사이
  if (daysUntilExpiry <= 7) {
    return 'D-7';
  }

  return null;
};
